var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAllResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,8.1h13c.6,0,1.2-.5,1.2-1.1s-.5-1.1-1.2-1.1h-13c-.6,0-1.1.5-1.1,1.1s.5,1.1,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,5.2c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5,1.5-.7,1.5-1.5-.7-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,13.1h13c.6,0,1.2-.5,1.2-1.1s-.5-1.1-1.2-1.1h-13c-.6,0-1.1.5-1.1,1.1s.5,1.1,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,10.4c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5,1.5-.7,1.5-1.5-.7-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,15.9h-6c-.6,0-1.1.5-1.1,1.1s.5,1.2,1.1,1.2h6c.6,0,1.2-.5,1.2-1.2s-.5-1.1-1.2-1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 17.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,20.8h-6c-.6,0-1.1.5-1.1,1.2s.5,1.2,1.1,1.2h6c.6,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,20.7c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5,1.5-.7,1.5-1.5-.7-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6,19.5l1.7-1.7c.4-.4.4-1.2,0-1.6-.4-.4-1.2-.4-1.6,0l-1.7,1.7-1.7-1.7c-.4-.4-1.2-.4-1.6,0-.4.4-.4,1.2,0,1.6l1.7,1.7-1.7,1.7c-.4.4-.4,1.2,0,1.6s1.2.4,1.6,0l1.7-1.7,1.7,1.7c.2.2.5.3.8.3s.6-.1.8-.3c.4-.4.4-1.2,0-1.6l-1.7-1.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAllResources);
export default __webpack_public_path__ + "static/media/remove-all-resources.69a101066d478b47e7e2999497065790.svg";
export { ForwardRef as ReactComponent };